import { rootRoute } from "@/routing/routes";
import { createRoute } from "@tanstack/react-router";
import { IndigenousPortalPage } from "./Portal";
import { IndigenousSignIn } from "./SignIn";

const index = createRoute({
  path: "indigenous",
  getParentRoute: () => rootRoute,
});

const portal = createRoute({
  path: "portal",
  getParentRoute: () => index,
  component: IndigenousPortalPage,
});

const signIn = createRoute({
  path: "signin",
  getParentRoute: () => index,
  component: IndigenousSignIn,
});

export const indigenousRoutes = index.addChildren([portal, signIn]);
